import type { CatalogueOwner } from "../data/catalogue-types";

/** How a catalogue's owner reads on screen (PROVISIONAL wording, docs/ui-wording.md); the record's `ownership` says the same. */
export function ownershipLabel(ownedBy: CatalogueOwner): string {
  return ownedBy === "db" ? "Managed in One" : "Managed in code";
}
